import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { FinancialDocumentRow } from 'src/features/financialDocumentRows/utils/types';

const RESOURCE = '/financial-documents/financial-document-row/:rowId/';

type QueryFnType = typeof queryFn;

interface DTO {
    rowId: string;
}
const queryFn = ({ rowId }: DTO): Promise<FinancialDocumentRow> => {
    return axios.get(formatResourcePath(RESOURCE, { rowId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetFinancialDocumentRow, RESOURCE as FINANCIAL_DOCUMENT_ROW_RESOURCE };
